import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import CalendarToolbar from './CalendarToolbar';
import ModelsCalendar from './ModelsCalendar';
import { ModelsCalendarProps } from './ModelsCalendar.types';
import { CALENDAR_DATE_KEY, CALENDAR_VIEW_KEY, CALENDAR_VIEWS } from '../../common/constants/calendar';
import { useCalendarState } from '../../hooks/useCalendarState';

type ModelsCalendarWithToolbarProps = Omit<
  ModelsCalendarProps,
  'hideToolbar' | 'controlledDate' | 'controlledView' | 'onDateChange' | 'onViewChange'
>;

const ModelsCalendarWithToolbar = (props: ModelsCalendarWithToolbarProps) => {
  const { calendarDate, setCalendarDate, calendarView, handleCalendarNavigate, handleCalendarViewChange } =
    useCalendarState({ dateStorageKey: CALENDAR_DATE_KEY, viewStorageKey: CALENDAR_VIEW_KEY });

  const handleCalendarDateSelect = useCallback((newDate: Date) => {
    setCalendarDate(newDate);
  }, [setCalendarDate]);

  return (
    <>
      <CalendarToolbar
        date={calendarDate}
        view={calendarView}
        onNavigate={handleCalendarNavigate}
        onViewChange={handleCalendarViewChange}
        onDateSelect={handleCalendarDateSelect}
        views={[...CALENDAR_VIEWS]}
      />
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <ModelsCalendar
          {...props}
          hideToolbar
          controlledDate={calendarDate}
          controlledView={calendarView}
          onDateChange={setCalendarDate}
          onViewChange={handleCalendarViewChange}
        />
      </Box>
    </>
  );
};

export default ModelsCalendarWithToolbar;
